module.exports = __webpack_public_path__ + "static/img/direct_hit_movie_thum_04.e387051.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/direct_hit_movie_thum_04.jpg
// module id = IdTs
// module chunks = 0